{
    "colors": {
        "background": "#004986",
        "primary": {
            "shade02": "#0B3C5A",
            "actionDefault": "#2679AD"
        },
        "button": {
            "action1": {
                "active": "#2679AD",
                "circleText": "#FFFFFF",
                "default": "#2679AD",
                "defaultIcon": "#2679AD",
                "focus": "#2679AD",
                "hover": "#215878",
                "text": "#FFFFFF",
                "textHover": "#FFFFFF"
            },
            "action2": {
                "active": "#2679AD",
                "text": "#2679AD",
                "textActive": "#133245",
                "textHover": "#215878"
            },
            "action3": {
                "underlineDefault": "#000000",
                "underlineActive": "#7D7D7D",
                "underlineHover": "#363636"
            }
        },
        "dataVisualization": {
            "pink": "#00A86B"
        },
        "datePicker": {
            "hover": "#2679AD",
            "icon": "#2679AD",
            "textActive": "#FFFFFF",
            "selected": "#2679AD",
            "selectedHover": "#2679AD",
            "headerColor": "#53565A"
        },
        "fileUpload": {
            "border": "#2679AD",
            "hoverBorder": "#2679AD",
            "icon": "#2679AD",
            "textColor": "#2679AD"
        },
        "formControl": {
            "border": "#2679AD",
            "default": "#2679AD",
            "hover": "#2679AD"
        },
        "link": {
            "default": "#2679AD",
            "hover": "#215878"
        },
        "navigation": {
            "active": "rgba(0, 244, 156, 0.8)",
            "selected": "#00F49C",
            "textActive": "#000000"
        },
        "paging": {
            "selected": "#2679AD"
        },
        "semantic": {
            "successSecondaryHover": "#F7F9FC",
            "success80": "#00A86B"
        },
        "shadows": { "default": "0px 0px 6px 0px #00000040" },
        "statusBar": {
            "active": "#007833",
            "complete": "#0B602F",
            "textActive": "#FFFFFF",
            "textDefault": "#FFFFFF"
        },
        "tab": {
            "default": "#2F7DAB",
            "hover": "#2F7DAB"
        },
        "text": {
            "highlight": "#2679AD"
        },
        "toggle": {
            "active": "#00A86B"
        }
    },
    "typography": {
        "fontFamilies": {
            "primary": "'InterORP', sans-serif",
            "secondary": "'InterORP', sans-serif"
        }
    }
}
